
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
components: {
Checker,
CheckerItem
},
name: 'maternal_form_a',
data(){
return{
type:'',
showSignature:false,
showUserSignature:false,
form:{
room_number:'',
entry_time:'',
name:'',
age:'',
blood_type:'',
national:'',
native_place:'',
maternity_hospital:'',
maternity_date:'',
maternity_type:'',
leave_hos_smary:'',
medication_history:'',
allergy_history:'',
leave_hos_diagnosis:'',
pregnancy_illness:'',
maternity_special_case:'',
acute_disease_treat:'',
contagion_stage:'',
spirit_history:'',
heart_assess:'',
have_heart_case:'',
have_heart_desc:'',
character_type:'',
emotion:'',
appetite:'',
diet_require:'',
diet_require_other:'',
diet_hobby_status:'',
has_diet_hobby_desc:'',
allergy_food:'',
micturition_case:'',
micturition_num:'',
urination_pain:'',
defecation_case:'',
defecation_num:'',
do_recovery_know:'',
attend_pregnancy_edu:'',
family_do_maternal_att:'',
family_other_desc:'',
temperature:'',
blood_pressure:'',
pulse_num:'',
breathing_num:'',
weight:'',
complexion:'',
mouth_mucosa:'',
activity:'',
lochia_colour:'',
lochia_amount:'',
lochia_sniff:'',
lochia_gdg:'',
incision_case:'',
incision_case_desc:'',
breast_case:'',
papilla_case:'',
milk_case:'',
milk_other_case:'',
special_find:'',
maternal_nursing_check:[],
maternal_nursing_want:'',
autograph:'',
customer_sign:'',
assess_time:''
},
option:{
penColor:"rgb(0, 0, 0)"
},
}
},
methods:{

save(){
let signature ='signature1'
const sigRef = this.$refs[signature]
const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
if (!comp || !comp.save) return
let png = comp.save()
this.form.autograph = encodeURI(png)
this.showSignature = true
},

edit(){
this.showSignature = false
this.form.autograph = ''
},

clear(){
let signature ='signature1'
const sigRef = this.$refs[signature]
if (Array.isArray(sigRef)) {
sigRef.forEach(c => c && c.clear && c.clear())
} else if (sigRef && sigRef.clear) {
sigRef.clear()
}
this.form.autograph = ''
},

saveUserName(){
let signature ='signature2'
const sigRef = this.$refs[signature]
const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
if (!comp || !comp.save) return
let png = comp.save()
this.form.customer_sign = encodeURI(png)
this.showUserSignature = true
},

editUserName(){
this.showUserSignature = false
this.form.customer_sign = ''
},

clearUserName(){
let signature ='signature2'
const sigRef = this.$refs[signature]
if (Array.isArray(sigRef)) {
sigRef.forEach(c => c && c.clear && c.clear())
} else if (sigRef && sigRef.clear) {
sigRef.clear()
}
this.form.customer_sign = ''
},

submitForm(){
let that=this
this.form.token=this.$cookie.get('token')
this.form.number_id=this.$cookie.get('id')
this.form.maternal_info_id=this.$route.query.id
this.form.store_id=this.$cookie.get('store_id')
let params = this.form




















if(
params.room_number==''||params.entry_time==''||params.name==''||params.age==''||params.blood_type==''||params.national==''||params.native_place==''||params.maternity_hospital==''||
params.maternity_date==''||params.maternity_type==''||params.leave_hos_smary==''||params.medication_history==''||params.allergy_history==''||params.leave_hos_diagnosis==''||
params.pregnancy_illness==''||params.maternity_special_case==''||params.acute_disease_treat==''||params.contagion_stage==''||params.spirit_history==''||params.heart_assess==''||
params.character_type==''||params.emotion==''||params.appetite==''||params.diet_require==''||params.diet_hobby_status==''||
params.allergy_food==''||params.micturition_case==''||params.micturition_num==''||params.urination_pain==''||params.defecation_case==''||
params.do_recovery_know==''||params.attend_pregnancy_edu==''||params.family_do_maternal_att==''||params.temperature==''||params.blood_pressure==''||
params.pulse_num==''||params.breathing_num==''||params.weight==''||params.complexion==''||params.mouth_mucosa==''||params.activity==''||params.lochia_colour==''||params.lochia_amount==''||
params.lochia_sniff==''||params.lochia_gdg==''||params.incision_case==''||params.incision_case_desc==''||params.breast_case==''||params.papilla_case==''||params.milk_case==''||
params.milk_other_case==''||params.special_find==''||params.maternal_nursing_check.length==0||params.autograph==''||params.customer_sign==''||params.assess_time==''
){
this.$vux.toast.show({
type: 'cancel',
text: '请完善表单',
})
return
}
console.info(params)
this.$vux.loading.show({
text: '正在加载'
})
Api.otherFormApi.addMaterCheckAssessData(params).then ( res => {
this.$vux.loading.hide()
console.info(res)
if(res.errcode==200){
this.$router.replace({
path:'/success',
query:{
id:this.$route.query.id,
form_id:res.data.id,
tabVal: this.$route.query.tabVal,
name : 'maternal_form_a',
}
})
}
})
},
apiMemberInfo(){
let params = {
token: this.$cookie.get('token'),
maternal_info_id: this.$route.query.id
}
Api.checkRoomApi.memberInfo(params).then ( res => {
console.info(res)
if(res.errcode == 1){
this.form.name = res.data.name
this.form.room_number = res.data.room_name
this.form.maternity_type = res.data.birth_type
}else{
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
})
},
goBack(){
this.$router.push({
path: './maternal_service',
query: {
tabVal: this.$route.query.tabVal,
id: this.$route.query.id
}
})
}
},
created(){
this.apiMemberInfo()
}
}



// WEBPACK FOOTER //
// ./src/components/maternal_form_a.vue